import styled from "styled-components";

const view1Image = require("../assets/icons/view1.png");
const view1cImage = require("../assets/icons/view1color.png");
const view2Image = require("../assets/icons/view2color.png");

export const MainContainer = styled.div`
  display: flex;
  h1,h2,h3,h4,h5,h6{
    margin: 0;
  }
`;
export const VerticalLine = styled.div`
  border-left: 1px solid ${(props) => props.theme.white5};
  position: relative;
  top: 0px;
  height: 850px; /* 세로 선의 높이 지정 */
`;
export const MenuContainer = styled.div`
  min-width: 300px;
  hr {
    width: 90%;
    margin: 10px 5%;
  }
`;

export const ViewSelectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  div {
    margin: 0 10px;
    width: 28px;
    height: 28px;
    transition: 0.2s;
    background-size: cover;
  }
  div:hover {
    width: 32px;
    height: 32px;
  }
  .view1 {
    background-image: url(${view1Image});
  }
  .view1:hover {
    background-image: url(${view1cImage});
  }
  .view2 {
    background-image: url(${view2Image});
  }
  .view2:hover {
    background-image: url(${view2Image});
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  input,
  select {
    margin: 0 10px;
    padding: 5px 5px 5px 15px;
    width: 180px;
    box-sizing: border-box;
    border: 0;
    background-color: ${(props) => props.theme.colorwhite0};
    border-radius: 20px;
    outline: none; /* 포커스 시 기본 테두리 제거 */
    color: ${(props) => props.theme.black1};
  }
  input::placeholder {
    color: ${(props) => props.theme.black2};
  }
  button {
    margin: 0 10px 0 0;
    width: 50px;
    border-radius: 20px;
    border: 2px solid ${(props) => props.theme.colorwhite1};
    background-color: ${(props) => props.theme.colorwhite1};
  }
  p {
    margin: 0 10px;
  }
`;

export const SearchButton = styled.div`
  margin: 0 10px;
  padding: 5px 5px 5px 15px;
  box-sizing: border-box;
  border: 0;
  background-color: ${(props) => props.theme.colorwhite0};
  border-radius: 20px;
  outline: none;
  color: ${(props) => props.theme.black1};
  text-align: center;
  &:hover {
    cursor: pointer;

    background-color: ${(props) => props.theme.white5};
  }
`;
export const SearchNavigate = styled.div`
  margin: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  img {
    height: 40px;
  }
  p {
    font-size: 15px;
    font-weight: 600;
    box-sizing: border-box;
    border-radius: 5px;
  }
  button {
    cursor: pointer;
    padding: 5px 10px;
    width: 120px;
    margin: 0 10px 0 0;
    border-radius: 20px;
    box-sizing: border-box;
    border: 0;
    background-color: ${(props) => props.theme.colorwhite0};
    border-radius: 20px;
    outline: none; /* 포커스 시 기본 테두리 제거 */
    color: ${(props) => props.theme.black1};
  }
  button:hover {
    background-color: ${(props) => props.theme.white5};
  }
`;

export const TrackingDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: unset;
  padding-bottom: 15px;
`;

export const CCTVInfoContainer = styled.div`
  height: 120px;
  padding: 10px;
  margin: 10px;
  background-color: ${(props) => props.theme.colorwhite1};
  border-radius: 10px;
`;

export const CCTVTrackingButton = styled.div`
  text-align: center;
  padding: 7px;
  margin: 10px;
  background-color: ${(props) => props.theme.colorwhite1};
  border-radius: 10px;
`;

export const CCTVEdit = styled.div`
  cursor: pointer;
  text-align: center;
  padding: 7px;
  margin: 10px;
  background-color: ${(props) => props.theme.colorwhite1};
  border-radius: 10px;
`;

export const CCTVListContainer = styled.div`
  background-color: ${(props) => props.theme.white1};
`;

export const CCTVViewContainer = styled.div`
  background-color: ${(props) => props.theme.colorwhite1};
  margin: 7px;
  span {
    padding: 1px;
    display: flex;
    align-items: center;
  }
  span p {
    padding: 15px 20px;
  }
`;

export const CCTVContainer = styled.div`
  padding: 10px;
`;

export const CCTVHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
`;

export const CCTVView = styled.div`
  width: 1200px;
  height: 700px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  overflow: hidden;
`;

export const CCTVDiv = styled.div`
  border: 1px solid ${(props) => props.theme.white4};
  text-align: center;
`;

export const CCTVControllerContainer = styled.div`
  padding-top: 30px;
`;
export const CCTVController = styled.div`
  display: flex;
  margin: 10px;
  justify-content: space-between;
  align-items: center;
  p {
    margin: 0 10px;
    border-radius: 20px;
    padding: 5px 15px;
    font-weight: 600;
    font-size: 20px;
    background-color: ${(props) => props.theme.colorwhite1};
  }
  span {
    display: flex;
  }
  button {
    cursor: pointer;
    padding: 5px 10px;
    width: 120px;
    margin: 0 10px 0 0;
    border-radius: 20px;
    box-sizing: border-box;
    border: 0;
    background-color: ${(props) => props.theme.colorwhite0};
    border-radius: 20px;
    outline: none; /* 포커스 시 기본 테두리 제거 */
    color: ${(props) => props.theme.black1};
  }
  button:hover {
    background-color: ${(props) => props.theme.white5};
  }
`;
